var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-item user-count"},[_c('x-angleIcon'),_vm._m(0),_c('div',{attrs:{"id":"userCount"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('i',{staticClass:"iconfont iconicon_jiantou"}),_vm._v("住户总数趋势")])
}]

export { render, staticRenderFns }